<template>
  <div class="stat-page">
    <search
      :formModel="formModel"
      :formButton="formButton"
      :statBusiType="statBusiType"
      :deviceModelBusiType="deviceModelBusiType"
    ></search>
    <el-row :gutter="40">
      <table-chart
        v-for="(v, id) in requestData"
        :normal-span="12"
        :key="id"
        :canvasName="id"
        :tableColumn="v.dimensions"
        :tableData="v.dataList"
        :chartOption="formatOption(v, id)"
        :title="title(id)"
        :color="statOpDict[id]().color"
      ></table-chart>
    </el-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import statOpDict from '../diffStatOp';
import { statChart } from '@/echartOption/stat';
import Search from '@/components/mTable/search';

export default {
  components: {
    Search,
    TableChart: () => import('@/components/table-chart')
  },
  props: {
    formModel: Object,
    requestData: Object,
    statBusiType: {
      type: Number,
      default: 1
    },
    deviceModelBusiType: Number,
    formButton: Array
  },
  data() {
    return {
      statOpDict
    };
  },
  computed: {
    ...mapState('admin', ['busiTypes'])
  },
  methods: {
    formatOption(v, id) {
      const { dataList, dimensions } = v;
      const op = statOpDict[id]();
      if (dataList) {
        op.op.dataset = {
          source: dataList,
          dimensions
        };
        dimensions.slice(1).forEach(() => {
          if (op.seriesType === 'bar') {
            op.op.series.push({ type: op.seriesType, barMaxWidth: 20 });
          } else if (op.seriesType === 'barStack') {
            op.op.series.push({ type: 'bar', stack: 'aaaa', barMaxWidth: 20 });
          } else {
            op.op.series.push({ type: op.seriesType });
          }
        });
      }
      return statChart(op.op);
    },
    title(id) {
      const res = this.busiTypes.filter(e => e.value === id)[0];
      return res && res.label;
    }
  }
};
</script>
